import { GraphQLClient } from "graphql-request";
import { mergeAll } from "remeda";
import { entries } from "../utils";
import { defineNuxtPlugin } from "#imports";
import { options as baseOptions } from "#build/graphql.options.mjs";
export default defineNuxtPlugin(async (nuxtApp) => {
  if (baseOptions.useFetchPolyfill) {
    globalThis.fetch = (await import("@buttercup/fetch")).fetch;
  }
  const runtimeOptions = nuxtApp.$config.public.graphql;
  const runtimeClients = runtimeOptions?.clients ?? {};
  const graphClients = {};
  for (const [clientName, clientConfig] of entries(baseOptions.clients)) {
    const runtimeConfig = runtimeClients?.[clientName];
    const mergedConfig = mergeAll([
      baseOptions,
      clientConfig,
      runtimeConfig ?? {}
    ]);
    graphClients[clientName] = new GraphQLClient(mergedConfig.endpoint, mergedConfig.options);
  }
  for (const [clientName, clientConfig] of entries(runtimeClients)) {
    if (clientName in graphClients)
      continue;
    const mergedConfig = mergeAll([baseOptions, clientConfig ?? {}]);
    graphClients[clientName] = new GraphQLClient(mergedConfig.endpoint, mergedConfig.options);
  }
  return {
    provide: {
      graphql: graphClients
    }
  };
});
